import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { useProject } from '../../../../context/ProjectContext';
import { REACTIONS } from '../../../../constants';

import scss from './LikedOutput.module.scss';
import EmptyMessagesList from '../../../../genie/components/messages-list/EmptyMessagesList';
import FrameCard from '../../frames/card/FrameCard';
import CommonPagination from '../../../../components/common-pagination/CommonPagination';
import { changeLikedImagesTable } from '../../../../redux/id8/id8Reducer';
import CommonLoader from '../../../../components/common-loader/CommonLoader';
import PhotoPreview from '../../frames/photo-preview/PhotoPreview';

function LikedOutput() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [imagesPreview, setImagesPreview] = useState(null);

  const { actions } = useProject();

  const likedImagesContent = useSelector((state) => state.id8.likedImagesContent);
  const { page, size, totalElements } = useSelector((state) => state.id8.likedImagesTableSettings);
  const isLoading = useSelector((state) => state.id8.isLikedImagesLoading);

  const handleClosePreview = () => {
    if (imagesPreview.frameData.images?.some((image) => image.reaction !== REACTIONS.LIKE)) {
      console.log('getLikedImages after dislike image in preview');
    }

    setImagesPreview(null);
  };

  const handleOpenPreview = ({ frameData, initialIndex }) => {
    setImagesPreview({ frameData, initialIndex });
  };

  const handleLike = (likedImage) => {
    const newUpdatedOn = new Date().toISOString();

    actions('likeImage', { imageId: likedImage.id, newReaction: '', updatedOn: newUpdatedOn });

    if (imagesPreview) {
      setImagesPreview((prevState) => ({
        ...prevState,
        frameData: {
          ...prevState.frameData,
          images: prevState.frameData.images.map((image) =>
            image.id === likedImage.id ? { ...image, reaction: '', updatedOn: newUpdatedOn } : image,
          ),
        },
      }));
      return;
    }

    // actions('getLikedImages', id);
    console.log('getLikedImages after dislike image');
  };

  const handleDownload = (id) => {
    actions('downloadImage', id);
  };

  const handleRevise = async (values) => {
    await actions('reviseImage', values);
  };

  const handleChangePage = (newPage) => {
    dispatch(changeLikedImagesTable({ page: newPage + 1 }));
  };

  useEffect(() => {
    if (imagesPreview) {
      const updatedFrameData = likedImagesContent.find((frame) => frame.id === imagesPreview.frameData.id);
      if (updatedFrameData) {
        setImagesPreview((prev) => ({
          ...prev,
          frameData: updatedFrameData,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [likedImagesContent]);

  return (
    <div className={scss.wrapper}>
      {!isLoading && likedImagesContent.length === 0 ? (
        <EmptyMessagesList />
      ) : (
        <div className={scss.cardsWrapper}>
          {likedImagesContent.map((frameData) => (
            <FrameCard
              key={frameData.id}
              frameData={frameData}
              onPreview={handleOpenPreview}
              onDownload={handleDownload}
              onLike={handleLike}
            />
          ))}
        </div>
      )}

      <CommonPagination
        activePage={page - 1}
        itemsPerPage={size}
        totalItemsCount={totalElements}
        onChangePage={handleChangePage}
      />

      <CommonLoader isLoading={isLoading} />

      <PhotoPreview
        isOpen={imagesPreview}
        onClose={handleClosePreview}
        imagePreview={imagesPreview}
        onDownload={handleDownload}
        onLike={handleLike}
        onRevise={handleRevise}
      />
    </div>
  );
}

export default LikedOutput;
